
export enum BusinessCategory {
  Accommodation = 'Accommodation',
  Accountant = 'Accountant',
  Acupuncture = 'Acupuncture',
  Adventure = 'Adventure',
  AdventurePark = 'AdventurePark',
  AdvertisingAgency = 'AdvertisingAgency',
  Airport = 'Airport',
  ATM = 'ATM',
  Attorney = 'Attorney',
  Attractions = 'Attractions',
  Bakery = 'Bakery',
  Bank = 'Bank',
  Bar = 'Bar',
  Barbershop = 'Barbershop',
  BearWatching = 'BearWatching',
  BeautyIndustry = 'BeautyIndustry',
  BeautySalon = 'BeautySalon',
  Beekeeping = 'Beekeeping',
  Bistro = 'Bistro',
  Butcher = 'Butcher',
  Cafe = 'Cafe',
  CarInspection = 'CarInspection',
  CarParts = 'CarParts',
  CarpetCleaning = 'CarpetCleaning',
  CarPolishing = 'CarPolishing',
  CarRepair = 'CarRepair',
  CarWash = 'CarWash',
  Castle = 'Castle',
  CaveVisit = 'CaveVisit',
  Chiropractor = 'Chiropractor',
  Church = 'Church',
  Cinema = 'Cinema',
  Climbing = 'Climbing',
  Clinic = 'Clinic',
  ClothingStore = 'ClothingStore',
  ClothingStoreAndFurrier = 'ClothingStoreAndFurrier',
  CompanyPrograms = 'CompanyPrograms',
  Concert = 'Concert',
  Construction = 'Construction',
  ConstructionAndInteriorDesign = 'ConstructionAndInteriorDesign',
  Cosmetics = 'Cosmetics',
  CruiseProgrammes = 'CruiseProgrammes',
  Cruising = 'Cruising',
  Culture = 'Culture',
  Cycling = 'Cycling',
  DailyMenu = 'DailyMenu',
  DairyProduct = 'DairyProduct',
  Dentist = 'Dentist',
  Dietitian = 'Dietitian',
  DIYStore = 'DIYStore',
  DrivingSchool = 'DrivingSchool',
  ElectricDeviceRepair = 'ElectricDeviceRepair',
  ElectronicsShop = 'ElectronicsShop',
  Entertainment = 'Entertainment',
  ExperienceConcert = 'ExperienceConcert',
  EyebrowsAndLashes = 'EyebrowsAndLashes',
  Fair = 'Fair',
  Farm = 'Farm',
  FarmStore = 'FarmStore',
  FastFood = 'FastFood',
  Festival = 'Festival',
  FishingShop = 'FishingShop',
  Fitness = 'Fitness',
  Florist = 'Florist',
  Football = 'Football',
  ForRent = 'ForRent',
  Furniture = 'Furniture',
  Gardening = 'Gardening',
  GasAndEnergy = 'GasAndEnergy',
  GiftShop = 'GiftShop',
  Greengrocer = 'Greengrocer',
  Grocery = 'Grocery',
  GuidedTour = 'GuidedTour',
  Gym = 'Gym',
  GymAndFitness = 'GymAndFitness',
  HairMedicine = 'HairMedicine',
  HandcraftedProducts = 'HandcraftedProducts',
  Healthcare = 'Healthcare',
  Hike = 'Hike',
  HikingShop = 'HikingShop',
  Hockey = 'Hockey',
  HomeDecoration = 'HomeDecoration',
  HorseRiding = 'HorseRiding',
  Hotel = 'Hotel',
  IceCream = 'IceCream',
  InteriorDesign = 'InteriorDesign',
  KidsFriendly = 'KidsFriendly',
  Kinetotherapist = 'Kinetotherapist',
  Leisure = 'Leisure',
  LocalEvents = 'LocalEvents',
  LocalNewsAndEvents = 'LocalNewsAndEvents',
  LocalProducers = 'LocalProducers',
  LocalSportEvents = 'LocalSportEvents',
  LocalTreasures = 'LocalTreasures',
  MakeupArtist = 'MakeupArtist',
  MakeupTattoo = 'MakeupTattoo',
  ManicureAndPedicure = 'ManicureAndPedicure',
  Marketplace = 'Marketplace',
  Massage = 'Massage',
  MedicalServices = 'MedicalServices',
  MensHaircut = 'MensHaircut',
  MetalShop = 'MetalShop',
  MoneyExchange = 'MoneyExchange',
  MountainBiking = 'MountainBiking',
  Museum = 'Museum',
  Music = 'Music',
  Musician = 'Musician',
  NailSalon = 'NailSalon',
  NatureHike = 'NatureHike',
  Naturopath = 'Naturopath',
  OffRoadTour = 'OffRoadTour',
  Ophthalmology = 'Ophthalmology',
  OralSurgeon = 'OralSurgeon',
  OrganicShop = 'OrganicShop',
  Orthopaedist = 'Orthopaedist',
  Paintball = 'Paintball',
  PaintShop = 'PaintShop',
  Party = 'Party',
  PastryShop = 'PastryShop',
  Performance = 'Performance',
  PersonalTrainer = 'PersonalTrainer',
  Pharmacy = 'Pharmacy',
  Photography = 'Photography',
  Physiotherapy = 'Physiotherapy',
  Piercing = 'Piercing',
  Pizza = 'Pizza',
  Podcasts = 'Podcasts',
  Pool = 'Pool',
  Print = 'Print',
  PrintingHouse = 'PrintingHouse',
  Production = 'Production',
  Psychologist = 'Psychologist',
  Pub = 'Pub',
  PublicAdministration = 'PublicAdministration',
  Restaurant = 'Restaurant',
  RestaurantsAndBars = 'RestaurantsAndBars',
  RockClimbing = 'RockClimbing',
  RomanticPrograms = 'RomanticPrograms',
  Running = 'Running',
  SecondHandShop = 'SecondHandShop',
  Sharpening = 'Sharpening',
  Shopping = 'Shopping',
  SolarPanels = 'SolarPanels',
  Spa = 'Spa',
  SpeechTherapist = 'SpeechTherapist',
  Sport = 'Sport',
  SportAndFitness = 'SportAndFitness',
  SportsShop = 'SportsShop',
  TanningStudio = 'TanningStudio',
  Tattoo = 'Tattoo',
  TattooRemoval = 'TattooRemoval',
  Taxi = 'Taxi',
  TeethWhitening = 'TeethWhitening',
  TheatricalPerformance = 'TheatricalPerformance',
  TherapyCenter = 'TherapyCenter',
  TobaccoShop = 'TobaccoShop',
  TouristInterest = 'TouristInterest',
  ToyShop = 'ToyShop',
  Tradition = 'Tradition',
  TraditionalStore = 'TraditionalStore',
  TyreService = 'TyreService',
  UpholsteryCleaning = 'UpholsteryCleaning',
  VehicleRepair = 'VehicleRepair',
  Veterinary = 'Veterinary',
  WaterSports = 'WaterSports',
  WaxingSalon = 'WaxingSalon',
  WeddingAndEvents = 'WeddingAndEvents',
  WeddingMakeupArtist = 'WeddingMakeupArtist',
  Wellness = 'Wellness',
  WhatToSee = 'WhatToSee',
  Winery = 'Winery',
  WomensHaircut = 'WomensHaircut',
  Workshop = 'Workshop',
  Zoo = 'Zoo',
  Other = 'Other',
}
